// @ts-ignore
import { useInView } from "react-intersection-observer";

import AccountCreation from "@/components/signup/account-creation";
import { JPDOverlayTemplate } from "@/components/signup/layouts";
import {
    useFreeIntent,
    usePremiumIntent,
    useStandardIntent
} from "@/components/user-context";
import { useFeatureExposed } from "@/utils/feature-exposed";
import { useIsMobile } from "@/utils/useIsMobile";

import {
    InputSubmitButton,
    JPDGetStartedHeading,
    SignupDefault
} from "../../components";

import {
    FreeSubheading,
    StandardSubheading
} from "./components/free-subheading";

export const LoggedOutJpd = () => {
    const isMobile = useIsMobile(800);
    return isMobile ? <SignupDefault /> : <CohortComponent />;
};

const CohortComponent = () => {
    const { ref, inView } = useInView();
    const isStandard = useStandardIntent();
    const isPremium = usePremiumIntent();
    const isFree = useFreeIntent();

    // Only fire useFeatureExposed if user has free, standard, or premium intent
    useFeatureExposed("gwp-7053-jpd-lofi-signup", "Test", {
        conditions: [inView, isFree || isStandard || isPremium],
        metadata: {
            isFree,
            isStandard,
            isPremium,
            userType: "logged-out"
        }
    });

    if (isFree) {
        return (
            <div ref={ref}>
                <LoggedOutJpdFree />
            </div>
        );
    }

    if (isStandard || isPremium) {
        return (
            <div ref={ref}>
                <LoggedOutJpdStandardPremium />
            </div>
        );
    }

    // bxpkit catch-all (paid editions if gate is off) - no ref needed since no tracking
    return <SignupDefault />;
};

const LoggedOutJpdFree = () => (
    <JPDOverlayTemplate size="sm">
        <JPDGetStartedHeading />
        <FreeSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </JPDOverlayTemplate>
);

const LoggedOutJpdStandardPremium = () => (
    <JPDOverlayTemplate size="sm">
        <JPDGetStartedHeading />
        <StandardSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </JPDOverlayTemplate>
);
